const videoPopup = document.querySelector('.video-popup');

if (videoPopup) {
  document.querySelectorAll('.open-video').forEach((btn) => {
    btn.addEventListener('click', () => {
      videoPopup.classList.add('is-active');
      toggleBodyScrollLock(true);
      document.body.classList.add('is-open-modal');
    });
  })

  const closePopup = () => {
    videoPopup.classList.remove('is-active');
    toggleBodyScrollLock(false);
    document.body.classList.remove('is-open-modal');
    videoPopup.querySelectorAll('video').forEach((video) => video.pause());
  };

  videoPopup.querySelector('.video-popup__modal-close').addEventListener('click', closePopup);
  document.addEventListener('keydown', ({ key }) => {
    if (key === 'Escape') closePopup();
  });

  // **************************************************

  const button = document.querySelector('.header-main__name-btn');
  const target = document.querySelector('.name-the-fish');

  if (button && target) {
    const hideButton = () => {
      button.classList.toggle('is-hidden', target.getBoundingClientRect().top < window.innerHeight);
    };

    window.addEventListener('scroll', hideButton);
    hideButton();
  }
}
